import React, { useState } from 'react'

import {
  PIICategoryTypeParametersList,
  addOrUpdatePIICategoryTypeParam,
} from '../../../assets/ts/data/pii/pii-category-type-parameters'
import Buttons from '../../../components/buttons/buttons'
import PageOverlayBusy from '../../../components/page-overlay/page-overlay-busy'
import { SEVERITY_OPTIONS } from '../../../utils/constants/global-constants'
import InputSelect from '../../../utils/controls/input-select'
import InputText from '../../../utils/controls/input-text'
import InputTextArea from '../../../utils/controls/input-text-area'
import DefinedFormats from './defined-formats'

const PiiConfiguration = () => {
  const [newCategory, setNewCategory] = useState<PIICategoryTypeParametersList>({
    CategoryContext: '',
    CategoryParamName: '',
    ParamAllowedDataTypes: '',
    ParamEnable: 'Yes',
    ParamMode: 3,
    Severity: '',
    Title: '',
  })

  const [catNewError, setCatNewError] = useState<boolean>(false)
  const [severityNewError, setSeverityNewError] = useState<boolean>(false)
  const [showLoaderAdd, setShowLoaderAdd] = useState<boolean>(false)
  const [showNewCat, setShowNewCat] = useState<boolean>(false)
  const [showPageOverlay, setShowPageOverlay] = useState<boolean>(false)

  const addPIICategory = async (data: PIICategoryTypeParametersList) => {
    if (data.CategoryParamName?.trim() !== '' && data.Severity !== '') {
      setCatNewError(false)
      setSeverityNewError(false)
      setShowPageOverlay(true)
      setShowLoaderAdd(true)

      const addedPIICategoryTypeParameters = await addOrUpdatePIICategoryTypeParam(data)
      // Generate a new ID and update the object with it
      await addOrUpdatePIICategoryTypeParam({
        CID: addedPIICategoryTypeParameters.ID,
        eKey: addedPIICategoryTypeParameters.eKey,
        eTag: addedPIICategoryTypeParameters.eTag,
      })
      setShowNewCat(false)
      setNewCategory({
        CID: -1,
        CategoryContext: '',
        CategoryParamName: '',
        ParamAllowedDataTypes: '',
        ParamEnable: 'Yes',
        ParamMode: 3,
        Severity: '',
        Title: '',
        eKey: '',
        eTag: '',
      })
    } else {
      if (data.CategoryParamName?.trim() === '') {
        setCatNewError(true)
      } else setCatNewError(false)
      if (data.Severity === '') {
        setSeverityNewError(true)
      } else setSeverityNewError(false)
    }
    setShowLoaderAdd(false)
    setShowPageOverlay(false)
  }

  const handleCancel = (): void => {
    setNewCategory({
      CID: -1,
      CategoryContext: '',
      CategoryParamName: '',
      ParamAllowedDataTypes: '',
      ParamEnable: 'Yes',
      ParamMode: 3,
      Severity: '',
      Title: '',
      eKey: '',
      eTag: '',
    })
    setShowNewCat(false)
    setCatNewError(false)
    setSeverityNewError(false)
  }
  const handleTextChange = (
    column: 'CategoryContext' | 'CategoryParamName' | 'Severity',
    value
  ): void => {
    setNewCategory({ ...newCategory, [column]: value })
  }
  const newCategoryClicked = () => {
    setShowNewCat(!showNewCat)
    setCatNewError(false)
    setSeverityNewError(false)
  }
  return (
    <>
      {showPageOverlay && <PageOverlayBusy />}
      <div className='container'>
        <div className='mt-2 whitebg border-radius p-3 h-100 '>
          <h3
            aria-label='Pre -  Defined categories '
            className='mb-2 poppins-semibold font-14 color-primary maxfitcontent py-2'
            tabIndex={0}
          >
            Pre - Defined Categories
          </h3>
          <div className='whitebg predefinedcat'>
            <DefinedFormats paramMode={2} showLoaderAdd={showLoaderAdd} />
          </div>
          <div className='d-flex pt-3 pb-2 align-items-center'>
            <h3
              aria-label='User  Defined categories '
              className='mb-2 poppins-semibold font-14 color-primary maxfitcontent py-2'
              tabIndex={0}
            >
              User - Defined Categories
            </h3>
            <Buttons
              aria-label='New Category'
              className='btn-xs font-12 py-1 text-white bgcolor-63 uppercase text-nowrap border-radius3 ms-auto poppins-medium '
              icon='icon-add me-1 font-10'
              label='New Category'
              onClick={() => newCategoryClicked()}
            />
          </div>
          {showNewCat && (
            <div className='card shadow5 mb-2'>
              <div className='d-flex p-2 justify-content-between border-bottom2 align-items-center'>
                <h3
                  aria-label='Add New Category'
                  className='poppins-semibold font-14 color-primary maxfitcontent py-2'
                  tabIndex={0}
                >
                  Add New Category
                </h3>
                <div className='ms-auto d-flex gap-1'>
                  <Buttons
                    aria-label='Save'
                    className='btn-xs font-12 btn-border text-white bgcolor-primary text-nowrap border-radius poppins-medium'
                    icon='icon-checked font-11 me-1'
                    label='Save'
                    onClick={(e) => addPIICategory(newCategory)}
                  />

                  <Buttons
                    aria-label='Cancel'
                    className='btn-xs font-12 btn-border2 bgcolor-5 darktext text-nowrap border-radius poppins-medium'
                    icon='icon-close font-10 me-1'
                    label='Cancel'
                    onClick={handleCancel}
                  />
                </div>
              </div>

              <div className='d-flex flex-column pt-0 card-body'>
                <div className='row'>
                  <div className='col-sm-12 col-md-5'>
                    <InputText
                      changeHandler={(e) => handleTextChange('CategoryParamName', e.target.value)}
                      className='form-sm font-13 sourcesanspro'
                      errorMessage={catNewError}
                      formClassName='form-vertical w-100 mb-1'
                      inputProps={{
                        className: 'font-12 poppins-medium title-color',
                        id: 'category',
                        name: newCategory.CategoryParamName,
                        placeholder: 'Category',
                      }}
                      isMandatory
                      label='Category'
                      msg='Please enter Category Name'
                      value={newCategory.CategoryParamName}
                    />
                    <InputSelect
                      className='form-sm w-100 font-13 sourcesanspro'
                      defaultSelect
                      error={severityNewError}
                      formClassName='form-vertical w-100 mb-1'
                      inputProps={{
                        className: 'font-12 poppins-medium title-color',
                        id: 'severity',
                        name: 'Severity',
                      }}
                      isMandatory
                      label='Severity'
                      msg='Please select Severity'
                      onChange={(e) => handleTextChange('Severity', e.target.value)}
                      options={SEVERITY_OPTIONS}
                      value={newCategory.Severity}
                    />
                  </div>
                  <div className='col-sm-12 col-md-7'>
                    <InputTextArea
                      className='h-auto font-13 sourcesanspro'
                      formClassName='ms-auto form-vertical mb-1'
                      inputProps={{
                        className: 'font-12 poppins-medium title-color',
                        id: 'context',
                        name: 'Context',
                        placeholder: 'Enter Context',
                      }}
                      label='Context'
                      onChange={(e) => handleTextChange('CategoryContext', e.target.value)}
                      rows='3'
                      value={newCategory.CategoryContext}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className='piiaccordiongroup whitebg userdefinedcat'>
            <DefinedFormats paramMode={3} showLoaderAdd={showLoaderAdd} />
          </div>
        </div>
      </div>
    </>
  )
}

export default PiiConfiguration
